import { GenericLazyString } from '@eventbrite/i18n';

export interface categoryMapProps {
    category: GenericLazyString;
    searchParam: string;
    // heapSelector: string;
    tagSelector: string;
    dates: DateType[];
}

export interface CategoryProps {
    categories: Array<categoryMapProps>;
    pageType: PageType;
    enableQuery: Function;
    dateSelection: DateOption;
    changeDateSelection: Function;
    setCategoryTag: Function;
    handleToggled: Function;
    selectedCategory: categoryMapProps;
    enableDateFilter: boolean | null;
}

export interface LocationData {
    isOnline: boolean;
    latitude: number | string;
    longitude: number | string;
}

export type PageType = 'dating';

export type DateOption = {
    text: string;
    searchValue: DateType;
};

export enum DateTypeEnum {
    ALL = 'all',
    PAST = 'past',
    CURRENT_FUTURE = 'current_future',
    TODAY = 'today',
    TOMORROW = 'tomorrow',
    THIS_WEEK = 'this_week',
    THIS_MONTH = 'this_month',
    THIS_WEEKEND = 'this_weekend',
    THIS_4_WEEKS = 'this_4_weeks',
    NEXT_MONTH = 'next_month',
}

export type DateType =
    | 'all'
    | 'past'
    | 'current_future'
    | 'today'
    | 'tomorrow'
    | 'this_week'
    | 'this_month'
    | 'this_weekend'
    | 'this_4_weeks'
    | 'next_month';

export type DateFilterDropdownProps = {
    dateSelection: DateOption;
    changeDateSelection: Function;
    enableQuery: Function;
    pageType: PageType;
};

export type DateTranslations = {
    [key: string]: GenericLazyString;
};
